// dependencies
import { List } from "immutable";

// selectors
import { getUI } from "Selectors/ui";

export const getReviewID = (state) => getUI(state).getIn(["review", "id"], "");
export const getReviewName = (state) => getUI(state).getIn(["review", "name"], "");
export const getReportID = (state) => getUI(state).getIn(["review_report", "id"], "");
export const getReportFormName = (state) => getUI(state).getIn(["review_report", "name"], "");
export const getAuthorName = (state) => getUI(state).getIn(["author", "name"], "");
export const getAuthorID = (state) => getUI(state).getIn(["author", "id"], "");
export const getSnapshots = (state) => getUI(state).getIn(["snapshots"], List());
export const getSubject = (state) => getUI(state).getIn(["subject", "name"], "");
export const getTotalCount = (state) => getUI(state).getIn(["totalCount"], "");
export const getCurrentPage = (state) => getUI(state).get("currentPage", 1);
